import { Alert as MuiAlert, Snackbar, SnackbarCloseReason } from '@mui/material'
import { SyntheticEvent, forwardRef, useEffect, useState } from 'react'

const Alert = forwardRef((props: any, ref) => <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />)

export default function CustomSnackBar({ errors, msgs }: any) {
  const [open, setOpen] = useState(false)
  const stringErrors: string = errors.join('')
  const stringMsgs: string = msgs.join('')

  useEffect(() => {
    if (hasErrorsOrMessages()) setOpen(true)
  }, [stringErrors, stringMsgs])

  const hasErrorsOrMessages = () => {
    const filterErrors = errors.filter((error: any, index: number) => error || (msgs[index] !== '' && msgs[index] !== null))
    return filterErrors.length > 0
  }

  const handleClose = (_: SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') return

    setOpen(false)
  }

  return (
    <>
      {errors.map((error: any, index: number) => {
        if (error || (msgs[index] !== '' && msgs[index] !== null)) {
          return (
            <Snackbar key={index} open={open} autoHideDuration={5000} onClose={handleClose}>
              <Alert onClose={handleClose} severity={error ? 'error' : 'success'}>
                {msgs[index]}
              </Alert>
            </Snackbar>
          )
        }
      })}
    </>
  )
}
